<template>
  <div>
    <template>
      <v-row class="mr-5">
        <strong class="text-h6 secondary--text font-weight-bold mt-4">{{ title }}</strong>
      </v-row>
      <v-row style="margin-top: -40px">
        <v-col cols="12" md="8" class="mt-12 mr-8" v-if="addUser || extend">
          <v-card class="rounded-lg success white--text py-3">
            <v-row>
              <v-col cols="12" md="2" class="d-flex justify-center">
                <v-img src="/img/icons/plans.svg" max-width="30" max-height="30"> </v-img>
              </v-col>
              <v-col cols="12" md="10" class="pt-4 d-flex text-right justify-center">
                <span>
                  بسته اشتراکی:
                  {{ company.plan_title }}
                </span>
                <span class="mr-10">
                  تاریخ انقضا:
                  {{ company.expired_at }}
                </span>
                <span class="mr-10">
                  تعداد کاربر:
                  {{ company.users_count }}
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" md="8" v-if="!addUser">
          <v-row :class="isXs ? 'mt-1' : 'mt-1 mb-4'">
            <v-col cols="12" md="3"></v-col>
            <v-col cols="12" md="6">
              <v-row>
                <v-toolbar flat class="rounded-lg white">
                  <v-col cols="4" v-for="duration in durations">
                    <v-btn
                      block
                      :small="false"
                      depressed
                      :class="{
                        'selected-duration': selectedDuration == duration.value,
                        'not-selected-duration': selectedDuration != duration.value,
                        'rounded-lg': true,
                      }"
                      @click="selectedDuration = duration.value"
                      >{{ duration.text }}
                      <template v-if="!isXs">
                        <v-img
                          class="mr-2"
                          v-if="duration.value == 180"
                          max-height="45"
                          max-width="45"
                          src="/img/icons/12percent.svg"
                        ></v-img>
                        <v-img
                          class="mr-2"
                          v-if="duration.value == 364"
                          max-height="45"
                          max-width="45"
                          src="/img/icons/25percent.svg"
                        ></v-img>
                      </template>
                    </v-btn>
                  </v-col>
                </v-toolbar>
              </v-row>
            </v-col>
            <v-col cols="12" md="3"></v-col>
          </v-row>

          <v-row class="text-center justify-center">
            <v-col class="text-center justify-center" cols="12" md="4" v-for="plan in plans">
              <v-card
                transition="fade-transition"
                v-if="selectedPlan != plan"
                @click="selectPlan(plan)"
                width="350"
                color="white"
                class="cursor-pointer rounded-lg mt-3"
                :class="{ 'disabled-plan': extend && company.plan.id != plan.id }"
              >
                <v-card
                  height="50"
                  class="ma-1 rounded-b-xl secondary white--text align-center justify-center pt-2"
                  flat
                >
                  <v-row class="align-center justify-center pt-3">
                    <v-img class="ml-5" src="/img/icons/min.svg" max-height="25" max-width="25"></v-img>
                    <span class="text-h6">
                      {{ plan.name }}
                    </span>
                    <span v-if="plan.id == 2" class="mr-2" style="font-size: 10px; color: #ff8700">
                      (( بیشترین خرید کاربران ))
                    </span>
                  </v-row>
                </v-card>
                <span style="font-size: small" class="secondary--text">{{ plan.explanation }}</span>
                <v-list flat class="white mt-3">
                  <v-list-item-group>
                    <v-list-item class="mr-5 ml-5 mt-min" v-for="(key, i) in featureKeys">
                      <v-list-item-icon>
                        <v-img
                          v-if="plan.excludedFeatures.includes(+key)"
                          max-height="25"
                          max-width="25"
                          src="/img/icons/time.svg"
                        ></v-img>
                        <v-img v-else max-height="25" max-width="25" src="/img/icons/checks.svg"></v-img>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="mr-3" v-text="features[key]"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="mr-5 ml-5 mt-min">
                      <v-list-item-icon>
                        <v-img max-height="20" max-width="20" src="/img/icons/logo.svg"></v-img>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="mr-3" v-text="'تعداد کاربر : ' + plan.usersCount"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="mr-5 ml-5 mt-min">
                      <v-list-item-icon>
                        <v-img max-height="20" max-width="20" src="/img/icons/logo.svg"></v-img>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          class="mr-3"
                          v-text="'تعداد جلسات آموزشی : ' + plan.trainingSessionsCount"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <v-card flat height="50" class="ml-5 mr-5 mb-5 pt-2 primary white--text rounded-lg">
                  <span class="text-h6" v-if="company || selectedDuration != 30">
                    قیمت :
                    {{ plan.prices[selectedDuration] | toMoney }}
                    تومان
                  </span>
                  <span class="text-h6" v-if="!company && selectedDuration == 30"> رایگان </span>
                </v-card>
              </v-card>

              <v-card
                v-if="selectedPlan == plan"
                @click="selectPlan(plan)"
                width="380"
                color="secondary"
                class="cursor-pointer rounded-lg"
              >
                <v-card height="50" class="ma-1 rounded-b-xl white secondary--text" flat>
                  <v-row class="align-center justify-center mt-3">
                    <v-img class="ml-5" src="/img/icons/primary_check.svg" max-height="25" max-width="25"></v-img>

                    <span class="text-h6">
                      {{ plan.name }}
                    </span>
                    <span v-if="plan.id == 2" class="mr-2" style="font-size: 10px; color: #ff8700">
                      (( بیشترین خرید کاربران ))
                    </span>
                  </v-row>
                </v-card>
                <span style="font-size: small" class="white--text">{{ plan.explanation }}</span>

                <v-list flat class="secondary white--text mt-3">
                  <v-list-item-group>
                    <v-list-item class="mr-5 ml-5 mt-min" v-for="(key, i) in featureKeys">
                      <v-list-item-icon>
                        <v-img
                          v-if="plan.excludedFeatures.includes(+key)"
                          max-height="25"
                          max-width="25"
                          src="/img/icons/time.svg"
                        ></v-img>
                        <v-img v-else max-height="25" max-width="25" src="/img/icons/checks.svg"></v-img>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="mr-3 white--text" v-text="features[key]"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="mr-5 ml-5 mt-min white--text">
                      <v-list-item-icon>
                        <v-img max-height="20" max-width="20" src="/img/icons/logo.svg"></v-img>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="mr-3" v-text="'تعداد کاربر : ' + plan.usersCount"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="mt-min mr-5 ml-5 white--text">
                      <v-list-item-icon>
                        <v-img max-height="20" max-width="20" src="/img/icons/logo.svg"></v-img>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          class="mr-3"
                          v-text="'تعداد جلسات آموزشی : ' + plan.trainingSessionsCount"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <v-card flat height="50" class="ml-5 mr-5 mb-5 pt-2 white secondary--text rounded-lg">
                  <span class="text-h6" v-if="company || selectedDuration != 30">
                    قیمت :
                    {{ plan.prices[selectedDuration] | toMoney }}
                    تومان
                  </span>
                  <span class="text-h6" v-if="!company && selectedDuration == 30"> رایگان </span>
                </v-card>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="!isXs" class="text-center justify-center d-flex">
            <v-btn large width="500" @click="infoDialog = true" depressed class="rounded-lg white secondary--text">
              مشاهده کامل جزئیات
            </v-btn>
          </v-row>
          <v-row class="justify-center d-flex">
            <v-col :cols="isXs ? 12 : 10">
              <v-card
                @click="toggleModule('payroll')"
                :style="isXs ? 'padding: 10px' : 'padding: 20px'"
                :class="selectedExtensions.includes('payroll') ? 'rounded-lg secondary' : 'rounded-lg snow'"
              >
                <v-card-text>
                  <v-row>
                    <v-img
                      :class="isXs ? 'cursor-pointer' : 'cursor-pointer mr-4'"
                      v-if="selectedExtensions.includes('payroll')"
                      src="/img/icons/primary_check.svg"
                      max-height="35"
                      max-width="35"
                    ></v-img>
                    <v-img
                      :class="isXs ? 'cursor-pointer' : 'cursor-pointer mr-4'"
                      v-else
                      src="/img/icons/min.svg"
                      max-height="35"
                      max-width="35"
                    ></v-img>
                    <span
                      :class="
                        selectedExtensions.includes('payroll')
                          ? 'text-h6 mr-3 white--text'
                          : 'text-h6 mr-3 secondary--text'
                      "
                      style="font-weight: bold; font-size: larger"
                    >
                      ماژول منابع انسانی
                    </span>
                    <template v-if="!isXs">
                      <v-spacer></v-spacer>
                      <v-hover v-slot="{ hover }">
                        <v-btn
                          text
                          class="mt-2"
                          @click="
                            payrollInfoDialog = true;
                            toggleModule('payroll');
                          "
                          :style="{ color: hover ? '#50CD89' : '#FFFFFF' }"
                        >
                          <span :class="selectedExtensions.includes('payroll') ? 'white--text' : 'secondary--text'">
                            مشاهده کامل امکانات و جزئیات
                          </span>
                          <v-icon
                            v-if="selectedExtensions.includes('payroll')"
                            class="mr-3"
                            :style="{ color: hover ? '#50CD89' : '#FFFFFF' }"
                          >
                            fa-eye</v-icon
                          >
                          <v-icon v-else class="mr-3" :style="{ color: hover ? '#50CD89' : '#002357' }"> fa-eye</v-icon>
                        </v-btn>
                      </v-hover>
                    </template>
                  </v-row>
                </v-card-text>
                <v-row>
                  <v-col :cols="isXs ? 12 : 8">
                    <v-list
                      flat
                      :class="
                        selectedExtensions.includes('payroll')
                          ? 'secondary white--text mt-5'
                          : 'white secondary--text mt-7'
                      "
                    >
                      <v-list-item-group>
                        <v-list-item class="mt-min">
                          <v-list-item-icon v-if="!isXs">
                            <v-img max-height="25" max-width="25" src="/img/icons/checks.svg"></v-img>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              :class="
                                selectedExtensions.includes('payroll') ? 'white--text mr-2' : 'secondary--text mr-2'
                              "
                            >
                              تهیه فیش حقوقی و خروجی از تمام قسمت ها
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item :class="isXs ? '' : 'mt-min'">
                          <v-list-item-icon v-if="!isXs">
                            <v-img max-height="25" max-width="25" src="/img/icons/checks.svg"></v-img>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              :class="
                                selectedExtensions.includes('payroll') ? 'white--text mr-2' : 'secondary--text mr-2'
                              "
                              >محاسبه هوشمند حق اولاد و پایه سنوات
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item :class="isXs ? '' : 'mt-min'">
                          <v-list-item-icon v-if="!isXs">
                            <v-img max-height="25" max-width="25" src="/img/icons/checks.svg"></v-img>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              :class="
                                selectedExtensions.includes('payroll') ? 'white--text mr-2' : 'secondary--text mr-2'
                              "
                            >
                              تهیه خروجی لیست حقوق جهت بارگزاری در سامانه بیمه و مالیات
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item :class="isXs ? '' : 'mt-min'">
                          <v-list-item-icon v-if="!isXs">
                            <v-img max-height="25" max-width="25" src="/img/icons/checks.svg"></v-img>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              :class="
                                selectedExtensions.includes('payroll') ? 'white--text mr-2' : 'secondary--text mr-2'
                              "
                              >امکان محاسبه و صدور فرم تسویه حساب سیستمی پرسنل
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-col>
                  <v-col :cols="isXs ? 12 : 4" :class="isXs ? 'mb-16' : 'mt-16 pt-10'">
                    <v-row class="justify-center d-flex">
                      <span class="primary--text font-weight-bold text-h4">
                        {{ durationDisplay[selectedDuration] }}
                      </span>
                    </v-row>
                    <v-row class="justify-center d-flex">
                      <span class="text-h4 primary--text font-weight-bold" v-if="company || selectedDuration != 30">
                        {{ extensions.payroll.prices[selectedDuration] | toMoney }}
                        تومان
                      </span>
                      <span class="text-h6" v-if="!company && selectedDuration == 30"> رایگان </span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" md="4" :class="isXs ? 'mt-5 mb-15' : 'mt-5'">
          <v-row class="justify-center d-flex">
            <v-col cols="12">
              <v-card
                :class="isXs ? 'white rounded-lg' : 'white rounded-lg fix-position'"
                :max-width="isXs ? '400' : '350'"
              >
                <v-card-title class="secondary white--text">
                  <v-img class="ml-5" src="/img/icons/shopping_dark.svg" max-width="30" max-height="30"></v-img>
                  سبد خرید
                </v-card-title>
                <v-simple-table>
                  <thead>
                    <tr>
                      <th colspan="1">ردیف</th>
                      <th colspan="2">عنوان</th>
                      <th class="text-left">مبلغ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="selectedPlan">
                      <td colspan="1">1</td>
                      <td colspan="2">
                        <v-icon v-if="!extend" x-small class="error--text ml-1" @click="selectedPlan = null">
                          fa-times
                        </v-icon>
                        {{ selectedPlan.name }} {{ durationDisplay[selectedDuration] }}
                      </td>
                      <td class="text-left" v-if="company || selectedDuration != 30">
                        {{ selectedPlan.prices[selectedDuration] | toMoney }}
                      </td>
                      <td class="text-left success--text" v-if="!company && selectedDuration == 30">رایگان</td>
                    </tr>
                    <tr v-for="m in selectedExtensions">
                      <td v-if="!selectedPlan">1</td>
                      <td v-if="selectedPlan">2</td>
                      <td colspan="2">
                        <v-icon v-if="!extend" x-small class="error--text ml-1" @click="toggleModule('payroll')">
                          fa-times
                        </v-icon>
                        {{ extensions[m].name }} {{ durationDisplay[selectedDuration] }}
                      </td>
                      <td class="text-left" v-if="company || selectedDuration != 30">
                        {{ extensions[m].prices[selectedDuration] | toMoney }}
                      </td>
                      <td class="text-left success--text" v-if="!company && selectedDuration == 30">رایگان</td>
                    </tr>

                    <tr>
                      <td v-if="!selectedPlan && selectedExtensions.length == 0" style="width: 15%">1</td>
                      <td v-else-if="!selectedPlan || selectedExtensions.length == 0" style="width: 15%">2</td>
                      <td v-else style="width: 10%">3</td>
                      <td style="width: 30%">
                        <v-icon
                          v-if="!extend && extraUsers != 0"
                          x-small
                          class="error--text ml-1"
                          @click="extraUsers = 0"
                          >fa-times
                        </v-icon>
                        کاربر اضافه
                      </td>
                      <td style="width: 30%">
                        <money
                          color="primary"
                          v-on:keypress="NumbersOnly"
                          v-model="extraUsers"
                          block
                          :disabled="extend"
                        />
                      </td>
                      <td class="text-left">{{ (extraUsers * extraUserPrice) | toMoney }}</td>
                    </tr>
                    <tr>
                      <th colspan="1">
                        <v-icon color="success">fa-calculator</v-icon>
                      </th>
                      <th colspan="2">مجموع</th>
                      <td class="text-left">{{ sum | toMoney }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="9">
                      <v-text-field
                        class="rounded-lg"
                        color="primary"
                        label="نام کسب و کار"
                        v-model="companyName"
                        :disabled="extend || addUser"
                      />
                    </v-col>
                    <v-col cols="12" md="3" class="justify-center d-flex">
                      <v-btn depressed @click="openPaymentDialog" color="success" class="pt-5 pb-5 rounded-lg"
                        >ادامه و پرداخت
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>

    <v-dialog
      v-model="payrollInfoDialog"
      class="rounded-lg"
      persistent
      @click:outside="payrollInfoDialog = false"
      max-width="600"
    >
      <v-card class="rounded-lg">
        <v-card-title class="primary white--text text-h6">
          امکانات ماژول منابع انسانی
          <v-spacer></v-spacer>
          <v-btn color="success" icon @click="payrollInfoDialog = false">
            <v-icon class="white--text">fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-5">
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            امکان ثبت ردیف پیمان های نامحدود
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            امکان ثبت اطلاعات جامع پرسنل
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            امکان ثبت اعضای خانواه هر پرسنل
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            امکان ثبت و صدور حکم کارگزینی
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            امکان ثبت مرخصی ساعتی،روزانه استعلاجی و سایر مرخصی ها به صورت موردی و تجمیعی
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            امکان ثبت غیبت
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            امکاان ثبت ماموریت ساعتی و روزانه به صورت موردی و تجمیعی
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            امکان ثبت ذخیره مزایای پایان خدمت( حق سنوات)
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            امکان ثبت مساعده یا وام
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            امکان ثبت سایر کسورات (مثل بیمه تکمیلی،جرائم و...)
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            امکان شخصی سازی تنظیمات کارگاه (اولیه)
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            محاسبه هوشمند پایه سنوات و حق اولاد (باتوجه به اطلاعات خانواده پرسنل و مدت کارکرد)
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            محاسبه عیدی و حق سنوات به صورت ماهانه
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            امکان محاسبه نوبت کاری و شب کاری طبق قوانین اداره کار
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            اعمال تمامی معافیت های مالیاتی قانون مالیات های مستقیم مثل ثبت هزینه های درمانی
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            امکان تهیه لیست پرداخت حقوق جهت ارائه به بانک
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            امکان تهیه خروجی لیست حقوق جهت بارگزاری در سامانه بیمه و مالیات
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            تهیه فیش حقوقی
          </v-row>
          <v-row>
            <v-img max-height="20" max-width="20" class="mr-5 ml-5" src="/img/icons/checks.svg"></v-img>
            امکان محاسبه و صدور فرم تسویه حساب سیستمی پرسنل
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="payrollInfoDialog = false"> بستن</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="infoDialog"
      class="rounded-lg"
      persistent
      @click:outside="infoDialog = false"
      max-width="1100"
      scrollable
    >
      <v-card class="rounded-lg">
        <v-card-title class="primary white--text text-h6">
          مشاهده کامل امکانات و جزئیات
          <v-spacer></v-spacer>
          <v-btn color="success" icon @click="infoDialog = false">
            <v-icon class="white--text">fa-times</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-5">
          <v-row class="text-center justify-center">
            <v-col class="text-center justify-center" cols="12" md="4" v-for="plan in plans">
              <v-card
                width="450"
                :color="selectedPlan != plan ? 'white' : 'secondary'"
                class="rounded-lg"
                @click="selectPlan(plan)"
              >
                <v-card
                  height="50"
                  :class="
                    selectedPlan != plan
                      ? 'ma-1 rounded-lg secondary white--text'
                      : 'ma-1 rounded-lg  white secondary--text'
                  "
                  flat
                >
                  <v-row class="align-center justify-center mt-3">
                    <v-img
                      v-if="selectedPlan == plan"
                      max-height="25"
                      max-width="25"
                      src="/img/icons/checks.svg"
                    ></v-img>
                    <span class="text-h6 mr-2">
                      {{ plan.name }}
                    </span>
                  </v-row>
                </v-card>
                <span style="font-size: small" :class="selectedPlan != plan ? 'secondary-text' : 'primary--text'">{{
                  plan.explanation
                }}</span>

                <v-list
                  flat
                  :class="selectedPlan != plan ? 'white secondary--text mt-3' : 'secondary white--text mt-3'"
                >
                  <v-list-item-group>
                    <v-list-item class="mr-5 ml-5 mt-min" v-for="(key, i) in dialogFeatureKeys">
                      <v-list-item-icon>
                        <v-img
                          v-if="plan.excludedFeatures.includes(+key)"
                          max-height="25"
                          max-width="25"
                          src="/img/icons/time.svg"
                        ></v-img>
                        <v-img v-else max-height="25" max-width="25" src="/img/icons/checks.svg"></v-img>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          :class="selectedPlan != plan ? 'mr-3 secondary--text' : 'mr-3 white--text'"
                          v-text="features[key]"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      :class="
                        selectedPlan != plan ? 'mt-min mr-5 ml-5 secondary--text' : 'mt-min mr-5 ml-5 white--text'
                      "
                    >
                      <v-list-item-icon>
                        <v-img max-height="20" max-width="20" src="/img/icons/logo.svg"></v-img>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="mr-3" v-text="'تعداد کاربر : ' + plan.usersCount"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      :class="
                        selectedPlan != plan ? 'mt-min mr-5 ml-5 secondary--text' : 'mt-min mr-5 ml-5 white--text'
                      "
                    >
                      <v-list-item-icon>
                        <v-img max-height="20" max-width="20" src="/img/icons/logo.svg"></v-img>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          class="mr-3"
                          v-text="'تعداد جلسات آموزشی : ' + plan.trainingSessionsCount"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog class="rounded-lg" v-model="paymentDialog" scrollable max-width="600px">
      <v-card class="rounded-lg">
        <v-card-title class="secondary white--text mb-5">
          <v-img class="ml-5" src="/img/icons/pay_dark.svg" max-width="30" max-height="30"></v-img>
          روش پرداخت
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <tbody>
              <tr>
                <th :style="isXs ? 'font-size: xx-small' : ''">
                  <span v-if="isXs"> موجودی </span>
                  <span v-else> موجودی کیف پول شما </span>
                </th>
                <td class="success--text" :style="isXs ? 'font-size: x-small' : ''">
                  <span class="success--text">{{ user.wallet.balance | toMoney }}</span>
                  <span v-if="!isXs"> تومان </span>
                </td>
                <td :style="isXs ? 'font-size: x-small' : ''">
                  <v-switch
                    inset
                    v-model="payFromWallet"
                    :label="isXs ? 'پرداخت' : 'پرداخت از کیف پول'"
                    :disabled="user.wallet.balance == 0"
                  />
                </td>
              </tr>
              <tr>
                <th :style="isXs ? 'font-size: x-small' : ''" colspan="2">مبلغ فاکتور</th>
                <td :style="isXs ? 'font-size: x-small' : ''">
                  <span>{{ sum | toMoney }}</span>
                  تومان
                </td>
              </tr>
              <tr>
                <th :style="isXs ? 'font-size: x-small' : ''" class="mb-5">تخفیف</th>
                <td :style="isXs ? 'font-size: x-small' : ''">
                  <span>{{ discountAmount | toMoney }}</span>
                </td>
                <td class="d-flex" :style="isXs ? 'font-size: x-small' : ''">
                  <v-text-field placeholder="کد تخفیف" v-model="discountCode" class="rounded-lg" />
                  <v-btn @click="verifyDiscountCode" depressed color="primary" class="rounded-lg mr-2 mt-1"
                    >اعمال
                  </v-btn>
                </td>
              </tr>
              <tr>
                <th :style="isXs ? 'font-size: x-small' : ''" colspan="2">مبلغ مالیات ارزش افزوده</th>
                <td :style="isXs ? 'font-size: x-small' : ''">
                  <span>{{ tax | toMoney }}</span>
                  تومان
                </td>
              </tr>

              <tr>
                <th :style="isXs ? 'font-size: x-small' : ''" colspan="2">مبلغ باقیمانده</th>
                <td :style="isXs ? 'font-size: x-small' : ''">
                  <span>{{ getRemain() | toMoney }}</span>
                  تومان
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="pay" depressed class="rounded-lg success white--text w-100px">پرداخت</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import SubscriptionMixin from "./mixin";
import { MFormMixin } from "@/components/m-form";
import GetUserApi from "@/views/panel/user/getUserApi.js";

export default {
  mixins: [SubscriptionMixin, GetUserApi, MFormMixin],
  props: {
    extend: {
      default: false,
    },
    addUser: {
      default: false,
    },
  },
  data() {
    return {
      features: {
        0: "مدیریت کاربران",
        1: "مدیریت کسب و کار",
        2: "حسابداری جامع 4 سطحی",
        3: "حسابداری جامع 8 سطحی",
        4: "تعریف، ویرایش و حذف حسابها",
        5: "خزانه داری ساده",
        6: "داشبورد گزارشات حرفه ای",
        7: "خزانه داری جامع",
        8: "نگهداری کالاها به روش ادواری",
        9: "نگهداری کالاها به روش دائمی",
        10: "انبارداری با 4 سطح کالا",
        11: "ارزیابی کالا به روش فایفو",
        12: "ارزیابی کالا به روش میانگین موزون",
        13: "بازرگانی جامع ",
        14: "تعریف نامحدود انبار",
        15: "پنل مشتریان و فاکتور آنلاین",
        16: "سامانه مودیان",
        17: "رابط برنامه نویسی (API)",
        18: "ارتباط با سایر ماژولهای نرم افزار",
        // 19: "تعداد کاربر",
        // 20: "تعداد آموزش آنلاین",
      },
      expandFeatures: false,
      plans: [
        {
          name: "پایه",
          explanation: "مناسب کسب و کارها و فروشگاه‌های نوپا",
          excludedFeatures: [3, 4, 7, 9, 11, 14, 16, 17, 18],
          usersCount: 1,
          trainingSessionsCount: 1,
          prices: {
            30: 275000,
            180: 1452000,
            364: 2475000,
          },
          id: 1,
        },
        {
          name: "پیشرفته",
          explanation: "مناسب کسب و کارها و فروشگاه‌های متوسط",
          excludedFeatures: [3, 7, 17, 18],
          usersCount: 1,
          trainingSessionsCount: 1,
          prices: {
            30: 425000,
            180: 2244000,
            364: 3825000,
          },
          id: 2,
        },
        {
          name: "حرفه ای",
          explanation: "مناسب کسب و کارها و فروشگاه‌ها در همه اندازه ها",
          excludedFeatures: [],
          usersCount: 2,
          trainingSessionsCount: 2,
          prices: {
            30: 700000,
            180: 3696000,
            364: 6300000,
          },
          id: 3,
        },
      ],
      extensions: {
        payroll: {
          id: 1,
          name: "منابع انسانی",
          prices: {
            30: 300000,
            180: 1584000,
            364: 2700000,
          },
        },
      },
      durationDisplay: {
        30: "یک ماهه",
        180: "شش ماهه",
        364: "یک ساله",
      },
      durations: [
        {
          text: "یک ماهه",
          value: 30,
        },
        {
          text: "شش ماهه",
          value: 180,
        },
        {
          text: "یک ساله",
          value: 364,
        },
      ],

      paymentDialog: false,

      companyName: "",
      selectedPlan: null,
      selectedExtensions: ["payroll"],
      selectedDuration: 364,
      extraUsers: 0,
      payrollInfoDialog: false,
      infoDialog: false,
      payFromWallet: false,
      discountCode: "",
      discountAmount: 0,
    };
  },
  computed: {
    title() {
      let title = "خرید اشتراک";
      if (this.extend) {
        title = "تمدید اشتراک";
      } else if (this.addUser) {
        title = "افزودن کاربر";
      }
      return this.setDocumentTitle(title);
    },
    extraUserPrice() {
      let price = 150000;
      // if(this.addUser) {
      //   let remainingDays = -moment().diff(this.toGDate(this.company.expired_at), 'days')
      //   price = Math.round(price * remainingDays / 364)
      // }
      return price;
    },
    featureKeys() {
      const keys = Object.keys(this.features);
      return keys.slice(0, 6);
    },
    dialogFeatureKeys() {
      const keys = Object.keys(this.features);
      return keys;
    },
    priceKeys() {
      console.log(Object.keys(this.durationDisplay));
      return Object.keys(this.durationDisplay);
    },
    sum() {
      let sum = 0;
      if (!this.company && this.selectedDuration == 30) {
        sum = 0;
      } else {
        if (this.selectedPlan) {
          sum = this.selectedPlan.prices[this.selectedDuration];
        }
      }
      sum += this.extraUsers * this.extraUserPrice;
      if (this.company || this.selectedDuration != 30) {
        this.selectedExtensions.forEach((m) => {
          sum += this.extensions[m].prices[this.selectedDuration];
        });
      }
      return sum;
    },
    tax() {
      return ((this.sum - this.discountAmount) * 9) / 100;
    },
  },
  watch: {
    "$route.params.extend"() {
      this.setDefaults();
    },
    "$route.params.addUser"() {
      this.setDefaults();
    },
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    setDefaults() {
      if (this.extend) {
        this.selectedPlan = this.plans.find((o) => o.id == this.company.plan);
        this.extraUsers = this.company.users_count - this.selectedPlan.usersCount;
        this.companyName = this.company.name;
        this.selectedExtensions = [];
        for (let extension of this.company.extensions) {
          this.selectedExtensions.push[this.getExtension(extension)];
        }
      } else if (this.addUser) {
        this.selectedPlan = null;
        this.selectedExtensions = [];
        this.companyName = this.company.name;
      } else {
        this.selectedPlan = this.plans[1];
        this.extraUsers = 0;
        this.companyName = "";
      }
    },
    getExtension(id) {
      for (let item in this.extensions) {
        if (this.extensions[item].id == id) {
          return item;
        }
      }
    },
    verifyDiscountCode() {
      this.request({
        url: this.endpoint("subscriptions/verifyDiscountCode"),
        method: "post",
        data: {
          discount_code: this.discountCode,
          factor_amount: this.sum,
        },
        success: (data) => {
          this.notify("کد تخفیف اعمال شد", "success");
          this.discountAmount = data.discount_amount;
        },
      });
    },
    openPaymentDialog() {
      if (!this.companyName) {
        this.notify("نام کسب و کار را وارد کنید", "warning");
      } else {
        this.paymentDialog = true;
      }
    },
    getRemain() {
      if (this.payFromWallet) {
        return Math.max(0, this.sum - this.discountAmount + this.tax - this.user.wallet.balance);
      } else return this.sum - this.discountAmount + this.tax;
    },
    selectPlan(plan) {
      if (this.extend) return;
      if (this.selectedPlan != plan) {
        this.selectedPlan = plan;
      } else {
        this.selectedPlan = null;
      }
    },
    toggleModule(codename) {
      if (this.extend) return;
      if (this.selectedExtensions.includes(codename)) {
        this.selectedExtensions.splice(this.selectedExtensions.indexOf(codename));
      } else {
        this.selectedExtensions.push(codename);
      }
    },
    pay() {
      if (this.addUser) {
        this.request({
          url: this.endpoint("subscriptions/addUser"),
          method: "post",
          data: {
            pay_from_wallet: this.payFromWallet,
            discount_code: this.discountCode,
            extra_users: this.extraUsers,
          },
          success: (data) => {
            if (
              data.redirect_url == "http://localhost:8080/panel/financialYears" ||
              data.redirect_url == "https://app.sobhan.net/panel/financialYears"
            ) {
              this.getUser();
              this.notify("کاربر با موفقیت افزوده شد", "success");
            }
            window.location = data.redirect_url;

            this.paymentDialog = false;
          },
        });
      } else if (this.extend) {
        this.request({
          url: this.endpoint("subscriptions/extend"),
          method: "post",
          data: {
            duration: this.selectedDuration,
            pay_from_wallet: this.payFromWallet,
            discount_code: this.discountCode,
          },
          success: (data) => {
            if (
              data.redirect_url == "http://localhost:8080/panel/financialYears" ||
              data.redirect_url == "https://app.sobhan.net/panel/financialYears"
            ) {
              this.getUser();
              this.notify("اشتراک شما تمدید شد", "success");
            }
            window.location = data.redirect_url;

            this.paymentDialog = false;
          },
        });
      } else {
        let selected_plan = null;
        if (this.selectedPlan) {
          selected_plan = this.selectedPlan.id;
        }
        this.request({
          url: this.endpoint("subscriptions/buy"),
          method: "post",
          data: {
            plan: selected_plan,
            extra_users: this.extraUsers,
            extensions: this.selectedExtensions.map((o) => this.extensions[o].id),
            duration: this.selectedDuration,
            company_name: this.companyName,
            pay_from_wallet: this.payFromWallet,
            discount_code: this.discountCode,
          },
          success: (data) => {
            if (
              data.redirect_url == "http://localhost:8080/panel/financialYears" ||
              data.redirect_url == "https://app.sobhan.net/panel/financialYears"
            ) {
              this.notify("کسب و کار جدید و اشتراک جدید ثبت شد");
            }
            window.location = data.redirect_url;
          },
        });
      }
    },
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
<style lang="scss">
.v-input--switch .v-label {
  font-size: xx-small;
  font-weight: bold;
}

.fix-position {
  position: fixed;
  top: 300px;
  left: 20px;
}

.mt-min {
  margin-top: -20px;
}

.top-border {
  border-top: 1px solid black !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

$color: rgb(0, 35, 87);
$primary-color: #ff8700;
.selected {
  border-right: 1px solid $color;
  border-left: 1px solid $color;
  background-color: $color;
  color: #fafafa;
}

.selected-duration {
  background-color: $color !important;
  color: white !important;
}

.not-selected-duration {
  background-color: #dae3ed !important;
  color: $color !important;
}

.disabled-plan {
  opacity: 0.4;
  filter: blur(1px);
  pointer-events: none;
}
</style>
